/**
 * Authentication hook
 *
 * Provides access to authentication state and methods.
 */

import { useContext } from 'react';
import { AuthContext } from '../context/authContextDef';
import type { AuthContextValue } from '../types/auth.types';

/**
 * Hook to access auth context
 * @throws Error if used outside AuthProvider
 */
export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
}

/**
 * Convenience hook for auth context
 */
export function useAuth(): AuthContextValue {
  return useAuthContext();
}
